(() => {
  document.querySelectorAll('[data-ys-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('.hero-slide')];
    const dots = [...carousel.querySelectorAll('[data-ys-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    carousel.querySelector('[data-ys-next]')?.addEventListener('click', () => show(index + 1));
    carousel.querySelector('[data-ys-prev]')?.addEventListener('click', () => show(index - 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.ysDot))));
    setInterval(() => show(index + 1), 6000);
  });
})();

(() => {
  const popup = document.querySelector('[data-ys-popup]');
  if (!popup) return;
  const key = 'yardsipper-spin-popup-dismissed-v3';
  const wheel = popup.querySelector('[data-ys-wheel]');
  const spinButton = popup.querySelector('[data-ys-spin]');
  const result = popup.querySelector('[data-ys-spin-result]');
  const close = () => { popup.hidden = true; try { window.localStorage.setItem(key, '1'); } catch (e) {} };
  try { if (window.localStorage.getItem(key) === '1') return; } catch (e) {}
  const delay = Number(popup.dataset.delay || 1000);
  window.setTimeout(() => { popup.hidden = false; }, delay);
  popup.querySelectorAll('[data-ys-popup-close]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) close(); });
  spinButton?.addEventListener('click', () => {
    if (popup.classList.contains('has-spun')) return;
    popup.classList.add('has-spun');
    if (wheel) wheel.style.transform = 'rotate(1845deg)';
    window.setTimeout(() => {
      if (result) result.hidden = false;
      if (spinButton) spinButton.textContent = 'CLAIM OFFER';
    }, 3200);
  });
})();
